import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private jwt: string = ''

  constructor(
    private httpClient: HttpClient
  ) {
    if (localStorage.getItem('token')) {
      this.jwt = localStorage.getItem('token') || ''
    }
  }

  generateToken(): Observable<void> {
    return this.httpClient.post<{ token: string }>(
      `${Config.baseURL}/${Config.easyDocEndpoints.authLogin}`,
      Config.authBody,
      { responseType: 'json' }
    ).pipe(
      map(({ token }) => {
        localStorage.setItem('token', token)
        this.jwt = token
      })
    )
  }

  get token(): string {
    return this.jwt
  }
}
